import {
  useDeathIndexSearch,
  type DataCollectionRecord,
} from '@ltvco/refresh-lib/hooks';
import { AdvancedSearchURLParams } from '@ltvco/refresh-lib/v2';
import React, { useEffect } from 'react';

interface DeathIndexesFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setDeathIndexResults: (data: DataCollectionRecord[] | undefined) => void;
}

export function DeathIndexesFetcher({
  searchData,
  setDeathIndexResults,
}: DeathIndexesFetcherProps) {
  const { deathIndexResults } = useDeathIndexSearch({
    firstName: searchData.fName,
    middleName: searchData.mName,
    lastName: searchData.lName,
    dateOfBirth:
      searchData.birthYear && searchData.birthMonth
        ? `${searchData.birthYear}-${searchData.birthMonth}`
        : undefined,
    dateOfDeath:
      searchData.deathYear && searchData.deathMonth
        ? `${searchData.deathYear}-${searchData.deathMonth}`
        : undefined,
    state: searchData.state,
    city: searchData.city,
    country: searchData.country,
  });

  useEffect(() => {
    setDeathIndexResults(deathIndexResults);
  }, [deathIndexResults, setDeathIndexResults]);

  return <React.Fragment />;
}
